import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7694528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-list" }
const _hoisted_2 = ["onClick"]

import { useRouter } from 'vue-router'
import { withDefaults, computed } from 'vue'
import { BaseInfoListItem, BaseInfoListItemRouteInfo } from '@/types/insurance'


export default /*#__PURE__*/_defineComponent({
  __name: 'base-info-list',
  props: {
    list: { default: () => [] },
    labelWidth: null,
    costInfoType: { type: Boolean },
    listItemJustifyContent: null,
    listItemMt: null
  },
  setup(__props: any) {

const props = __props as { list: Array<BaseInfoListItem>, labelWidth?: number | string, costInfoType?: boolean, listItemJustifyContent?: string, listItemMt?: number };


const $router = useRouter()
const labelStyle = computed(() => {
  const width = props.labelWidth
  if (!width) {
    return ''
  }
  return {
    width: typeof width === 'number' ? width + 'px' : width,
  }
})
function getListItemStyle(index: number) {
  const arr = []
  const listItemJustifyContent = props.listItemJustifyContent
  const listItemMt = props.listItemMt
  if (listItemJustifyContent) {
    arr.push(`justify-content: ${listItemJustifyContent}`)
  }
  if (listItemMt && index > 0) {
    arr.push(`margin-top: ${listItemMt}px`)
  }
  return arr.join(';')
}
function getNoticeWrapStyle(item: BaseInfoListItem) {
  if (!item.type || !item.noticeInfo) {
    return ''
  }
  const noticeInfo = item.noticeInfo
  return {
    backgroundColor: noticeInfo.bgColor,
    color: noticeInfo.color,
  }
}
function getIconClass(item: BaseInfoListItem) {
  if (!item.type || !item.noticeInfo) {
    return ''
  }
  const noticeInfo = item.noticeInfo
  return noticeInfo.icon || ''
}
function gotoUrl(item: BaseInfoListItemRouteInfo) {
  const action = item.action || 'push'
  const handle = action === 'replace' ? $router.replace : $router.push
  if (item.name) {
    handle(item)
  } else if (item.path) {
    handle({ path: item.path })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle(getListItemStyle(index))
      }, [
        (item.type)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "notice-wrap",
              style: _normalizeStyle(getNoticeWrapStyle(item))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(getIconClass(item))
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(item.noticeInfo.text), 1)
            ], 4))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "label",
                style: _normalizeStyle(_unref(labelStyle))
              }, _toDisplayString(item.label), 5),
              (item.routeInfo)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (gotoUrl(item.routeInfo)),
                    class: "link"
                  }, _toDisplayString(item.value), 9, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "value",
                    style: _normalizeStyle(item.valueStyle)
                  }, _toDisplayString(item.value), 5))
            ], 64))
      ], 4))
    }), 128))
  ]))
}
}

})